import { useState, useEffect, useCallback } from 'react';
import { useAuthenticatedFetchWithWorkspace } from '../Keycloak/useAuthenticatedFetchWithWorkspace';

export interface PersonalField {
  NAME: string;
  ANCHOR: string;
  AVERAGE_LENGTH: number;
}

export type PersonalFieldsByCategory = { [category: string]: PersonalField[] };

export type PersonalFieldsChannel = 'SMS' | 'EMAILING' | 'CASHDESK';

interface WorkspaceEssentialDatas {
  PERSONAL_FIELDS?: Partial<Record<PersonalFieldsChannel, PersonalFieldsByCategory>>;
  [key: string]: unknown;
}

type EssentialDatasResponse = Record<string, WorkspaceEssentialDatas>;

const useGetPersonalFields = (channel: PersonalFieldsChannel) => {
  const { authFetch, isReady, workspaceId } = useAuthenticatedFetchWithWorkspace();
  const [data, setData] = useState<PersonalFieldsByCategory>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetch = useCallback(async () => {
    if (!isReady || !workspaceId) return;
    setLoading(true);
    setError('');
    try {
      const result: EssentialDatasResponse = await authFetch('/getEssentialDatasWorkspace', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ workspace: workspaceId }),
      });
      const fields = result?.[workspaceId]?.PERSONAL_FIELDS?.[channel] ?? {};
      setData(fields);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Erreur chargement champs personnalisés');
    } finally {
      setLoading(false);
    }
  }, [authFetch, isReady, workspaceId, channel]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error };
};

export default useGetPersonalFields;
